import Div from '../Div'
import { imgUrl } from '../../helper'

export default function TextWidget({logoSrc, logoAlt, text}) {
  return (
    <Div className="cs-text_widget">
      <img src={imgUrl(logoSrc)} alt={logoAlt} />
      <p>{text}</p>
    </Div>
  )
}
